import { useShareTokenContext } from '../contexts/ShareTokenContext';
import { useMusic24Capabilities } from './useMusic24Capabilities';

/**
 * Whether the Listening Score UI should render. On public share-token pages
 * there is no user JWT — the owner exposed their own page and the server scopes
 * access via the token (assertListeningInsightsAccess lets share-token calls
 * through), so render and let the backend decide, exactly like the sibling
 * charts. Authenticated views require the license capability, read from the licence slice, not
 * the session token's frozen claims.
 */
export const useCanViewListeningInsights = (): boolean => {
  const { isPublicMode } = useShareTokenContext();
  const capabilities = useMusic24Capabilities();
  return isPublicMode || capabilities.canViewListeningInsights;
};
